import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import ReactDOM from 'react-dom/'
import './App.css';
import { ThemeProvider } from "@material-ui/core/styles";
import { theme } from "components/theme";
import {PrizePicks} from 'registerations';
import { UserModal } from 'registerations/components/user-info-modal';
import { usePrizePicksProjections } from 'registerations/hooks/prizePicksProjections';

const App = () => {
  const {loading: loading} = usePrizePicksProjections();

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <Router>
          <Switch>
            <Route path="/login">
              <UserModal />
            </Route>
            <Route path="/home">
              <PrizePicks />
            </Route>
            {loading ? <UserModal /> : <Redirect to="/home" />}
            <Route path="*">
              <h2>Page Not Found</h2>
            </Route>
          </Switch>
        </Router>
      </ThemeProvider>
    </div>
  );
};

export default App;
